import { render, staticRenderFns } from "./EmployeeKPI.vue?vue&type=template&id=4672ac8c&scoped=true&"
import script from "./EmployeeKPI.vue?vue&type=script&lang=js&"
export * from "./EmployeeKPI.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeKPI.vue?vue&type=style&index=0&id=4672ac8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672ac8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
